import { render, staticRenderFns } from "./AuthorLinkControl.vue?vue&type=template&id=1602982a"
import script from "./AuthorLinkControl.vue?vue&type=script&lang=js"
export * from "./AuthorLinkControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports